import { FieldConfig, Option } from './ContractDetails';

const toOptions = (values: string[]): Option[] => values.map((v) => ({ key: v, value: v }));

const typeOfCompanyList: Option[] = toOptions([
  'Customer',
  'Prospect',
  'Vendor',
  'Internal Customer',
]);
const typeOfAgreementList: Option[] = toOptions([
  'New agreement',
  'Extension/ Amendment/ Adoption',
  'Addendum',
  'SOW',
  'Project specific agreement',
  'Commitments',
  'POC/Trials',
  'CarveOut',
  'Others',
]);
// const currentStatusList: Option[] = toOptions([
//   'Initial request',
//   'Internal review',
//   'Sent for external review',
//   'Deviations received',
//   'Approval requested',
//   'Approval received',
//   'Not approved',
//   'In authoring',
//   'In signature - internally',
//   'In signature - externally',
//   'Signed',
//   'In effect',
//   'Expired',
//   'Terminated',
//   'In Effect, auto-renewed',
//   'Request Cancelled',
//   'Amended',
//   'Partner Approved',
// ]);
const currentStatusList: Option[] = toOptions([
  'Pending',
  'Approved',
  'Rejected',
  'NA',
  'Expired/Terminated',
  'CarveOut',
]);
const partnerSelectionStatusList: Option[] = toOptions([
  'Approved',
  'Denied',
  'Under review',
  'Pending activation',
  'renewed',
  'In Effect, auto-renewed',
]);
// Fallback territory options; overridden at runtime with the country list API.
const territoryList = [
  { id: 'Australia', value: 'Australia' },
  { id: 'New Zealand', value: 'New Zealand' },
  { id: 'India', value: 'India' },
  { id: 'Singapore', value: 'Singapore' },
];

export const contractFieldConfig: Record<string, FieldConfig> = {
  accountNumber: { key: 'accountNumber', label: 'Account number', type: 'text', required: true, disabled: true },
  agreementId: { key: 'agreementId', label: 'Agreement ID', type: 'text', required: true, disabled: true },
  validatorEmail: { key: 'validatorEmail', label: 'Validator email', type: 'text', required: true },
  validatorName: { key: 'validatorName', label: 'Validator name', type: 'text', required: true },
  renewalNotifications: { key: 'renewalNotifications', label: 'Renewal notifications', type: 'radio', required: true },
  legalEntityNokia: { key: 'legalEntityNokia', label: 'Legal entity name (Nokia)', type: 'text', required: true },
  renewalEnabled: { key: 'renewalEnabled', label: 'Renewal enabled?', type: 'radio', required: true },
  renewalPeriod: { key: 'renewalPeriod', label: 'Renewal period', type: 'text', required: true },
  companyId: { key: 'companyId', label: 'Company ID', type: 'text', required: true },
  previousContractInstance: { key: 'previousContractInstance', label: 'Previous contract instance', type: 'radio', required: true },
  remarks: { key: 'remarks', label: 'Remarks', type: 'textarea', required: true },
  // typeOfCompany: { key: 'typeOfCompany', label: 'Type of company', type: 'select', required: true, options: typeOfCompanyList },
  typeOfCompany: { key: 'typeOfCompany', label: 'Type of company', type: 'text', required: false, disabled: true },
  contractName: { key: 'contractName', label: 'Contract name', type: 'text', required: true },
  contractEndDate: { key: 'contractEndDate', label: 'Contract end date', type: 'date', required: true },
  territory: { key: 'territory', label: 'Territory', type: 'multiselect', required: true, multiOptions: territoryList },
  legalEntityCustomer: { key: 'legalEntityCustomer', label: 'Legal entity name (Customer)', type: 'text', required: true },
  requestDate: { key: 'requestDate', label: 'Request date', type: 'date' },
  keyAccount: { key: 'keyAccount', label: 'Key account', type: 'text', required: true },
  contractStartDate: { key: 'contractStartDate', label: 'Contract start date', type: 'date', required: true },
  typeOfAgreement: { key: 'typeOfAgreement', label: 'Type of agreement', type: 'select', required: true, options: typeOfAgreementList, disabled: true },
  sourceStatus: { key: 'sourceStatus', label: 'Source Status', type: 'text', required: false, disabled: true },
  sourceAgreementType: { key: 'sourceAgreementType', label: 'Source Agreement Type', type: 'text', required: false, disabled: true },
  currentStatus: { key: 'currentStatus', label: 'Current status', type: 'select', required: true, options: currentStatusList, disabled: true },
  accountManager: { key: 'accountManager', label: 'Account manager', type: 'text' },
  partnerSelectionStatus: { key: 'partnerSelectionStatus', label: 'Partner selection process status', type: 'select', required: true, options: partnerSelectionStatusList },
  deputyOwner: { key: 'deputyOwner', label: 'Deputy owner/sales organization LM/RL', type: 'text', required: true },
};

// Key rendered as a full-width row above the grid.
export const contractTopFieldKey = 'accountNumber';

/**
 * Required field keys for submission — derived from contractFieldConfig.
 * Edit the `required` flag on any entry above to add/remove a field from this list.
 * Disabled fields (e.g. agreementId) are excluded since the user cannot edit them.
 */
export const contractRequiredFields: string[] = Object.values(contractFieldConfig)
  .filter((f) => f.required && !f.disabled)
  .map((f) => f.key);

// Row-major order of the 2-column grid (null = empty cell to keep alignment).
export const contractGridOrder: (string | null)[] = [
  'agreementId', 'contractName',
  'legalEntityNokia', 'legalEntityCustomer',
  'companyId', 'keyAccount',
  'typeOfCompany', 'accountManager',
  'sourceAgreementType', 'typeOfAgreement',  
  'requestDate', 'deputyOwner',
  'contractStartDate', 'contractEndDate',
  'sourceStatus', 'currentStatus',
  'partnerSelectionStatus', 'previousContractInstance',
  'validatorName', 'validatorEmail',
  'renewalPeriod', 'renewalEnabled',
  'renewalNotifications', null,
  'territory', 'remarks',
];
